var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApiType = function SvgApiType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "api_type_svg2__a",
    x1: 49.47,
    x2: 161.22,
    y1: 165.18,
    y2: 42.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_type_svg2__a",
    id: "api_type_svg2__b",
    x1: 27.87,
    x2: 139.62,
    y1: 145.54,
    y2: 22.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_type_svg2__a",
    id: "api_type_svg2__c",
    x1: 19.73,
    x2: 131.48,
    y1: 138.14,
    y2: 15.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_type_svg2__a",
    id: "api_type_svg2__d",
    x1: 44.11,
    x2: 155.86,
    y1: 160.3,
    y2: 37.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_type_svg2__a",
    id: "api_type_svg2__e",
    x1: 29.5,
    x2: 141.25,
    y1: 147.02,
    y2: 24.1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.62 120.99a7.246 7.246 0 0 0 6.36-7.18v-5.1c18.35-.92 33-16.09 33-34.66 0-16.62-11.93-30.94-28.06-34.1a26.88 26.88 0 0 0-24.75-16.38c-1.43 0-2.85.11-4.25.33a50.4 50.4 0 0 0-6.31-8.18c-1.25-1.32-3.34-1.38-4.66-.12s-1.38 3.34-.12 4.66c2.56 2.7 4.77 5.71 6.56 8.95a3.3 3.3 0 0 0 3.71 1.59c1.64-.42 3.35-.64 5.07-.64 8.7 0 16.42 5.54 19.22 13.78.4 1.19 1.44 2.04 2.68 2.21 13.86 1.89 24.32 13.88 24.32 27.88 0 15.52-12.63 28.15-28.15 28.15h-14.18c-1.82 0-3.3 1.48-3.3 3.3s1.48 3.3 3.3 3.3h9.34v5.01c0 .32-.24.59-.56.63l-15.2 1.85a3.3 3.3 0 0 0-2.75 2.29c-.77 2.48-1.79 4.92-3.02 7.27-.6 1.15-.48 2.54.32 3.57l9.44 12.07c.2.25.18.62-.05.84l-11.75 11.75a.64.64 0 0 1-.84.05l-12.07-9.44c-1.02-.8-2.41-.93-3.57-.32a43.6 43.6 0 0 1-7.27 3.02 3.29 3.29 0 0 0-2.29 2.75l-1.85 15.2c-.04.32-.31.55-.63.55H91.69c-.32 0-.59-.24-.63-.56l-1.85-15.2a3.3 3.3 0 0 0-2.29-2.75c-2.48-.77-4.92-1.79-7.27-3.02-1.14-.6-2.54-.48-3.57.32l-12.07 9.44a.64.64 0 0 1-.84-.05L51.42 142.3a.63.63 0 0 1-.05-.84l9.44-12.07c.8-1.02.93-2.42.32-3.57a43.6 43.6 0 0 1-3.02-7.27 3.29 3.29 0 0 0-2.75-2.29l-15.2-1.85a.63.63 0 0 1-.55-.63v-5.01h33.72c1.63 13.27 12.95 23.59 26.66 23.59s25.03-10.31 26.66-23.59h10.77c1.82 0 3.3-1.48 3.3-3.3s-1.48-3.3-3.3-3.3H34.77c-15.52 0-28.15-12.63-28.15-28.15 0-14.01 10.45-25.99 24.32-27.88a3.29 3.29 0 0 0 2.68-2.21 20.29 20.29 0 0 1 19.22-13.78c1.72 0 3.43.22 5.07.64a3.3 3.3 0 0 0 3.71-1.59c7.74-13.96 22.45-22.63 38.39-22.63 7.7 0 15.27 2.02 21.89 5.85 1.58.91 3.6.37 4.51-1.2a3.31 3.31 0 0 0-1.2-4.51 50.43 50.43 0 0 0-25.19-6.73C82.5-.02 66.27 9.09 57.1 23.9c-1.4-.22-2.82-.33-4.25-.33-10.85 0-20.56 6.5-24.75 16.38C11.95 43.11.02 57.43.02 74.06c0 18.56 14.65 33.73 33 34.65v5.1c0 3.65 2.73 6.73 6.35 7.18l13.13 1.6c.54 1.49 1.15 2.96 1.83 4.4l-8.16 10.43a7.24 7.24 0 0 0 .58 9.57l3.54 3.54-10.66 10.66c-.62.62-.97 1.46-.97 2.33v17.92c-3.66 1.35-6.29 4.84-6.29 8.97 0 5.29 4.3 9.59 9.59 9.59s9.59-4.3 9.59-9.59c0-4.12-2.63-7.61-6.29-8.97v-16.56l9.69-9.69 3.54 3.54a7.23 7.23 0 0 0 9.57.58l10.43-8.16c1.44.68 2.91 1.29 4.4 1.83l1.6 13.13c.44 3.62 3.53 6.35 7.18 6.35h5.01v8.96c-3.66 1.35-6.29 4.84-6.29 8.97 0 5.29 4.3 9.59 9.59 9.59s9.59-4.3 9.59-9.59c0-4.12-2.63-7.61-6.29-8.97v-8.96h5.01c3.65 0 6.73-2.73 7.18-6.35l1.6-13.13c1.49-.54 2.96-1.15 4.4-1.83l10.43 8.16a7.24 7.24 0 0 0 9.57-.58l3.54-3.54 9.69 9.69v16.56c-3.66 1.35-6.29 4.84-6.29 8.97 0 5.29 4.3 9.59 9.59 9.59s9.59-4.3 9.59-9.59c0-4.12-2.63-7.61-6.29-8.97v-17.92c0-.87-.35-1.71-.97-2.33l-10.66-10.66 3.55-3.55a7.24 7.24 0 0 0 .58-9.57l-8.16-10.43c.68-1.44 1.29-2.91 1.83-4.4l13.13-1.6Zm-60.62 4.8c-10.06 0-18.41-7.37-19.99-16.99H120c-1.58 9.62-9.93 16.99-20 16.99M41.98 193.4c-1.65 0-2.99-1.34-2.99-2.99s1.34-2.99 2.99-2.99 2.99 1.34 2.99 2.99-1.34 2.99-2.99 2.99m58.02 0c-1.65 0-2.99-1.34-2.99-2.99s1.34-2.99 2.99-2.99 2.99 1.34 2.99 2.99-1.34 2.99-2.99 2.99m58.02 0c-1.65 0-2.99-1.34-2.99-2.99s1.34-2.99 2.99-2.99 2.99 1.34 2.99 2.99-1.34 2.99-2.99 2.99",
    style: {
      fill: "url(#api_type_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6 38.52h-5.98c-6.16 0-11.16 5.01-11.16 11.16V82.7c0 6.16 5.01 11.16 11.16 11.16h72.75c6.16 0 11.16-5.01 11.16-11.16V49.68c0-6.15-5.01-11.16-11.16-11.16H83.22c-1.82 0-3.3 1.48-3.3 3.3s1.48 3.3 3.3 3.3h53.15c2.52 0 4.57 2.05 4.57 4.56V82.7c0 2.52-2.05 4.57-4.57 4.57H63.63c-2.52 0-4.57-2.05-4.57-4.57V49.68c0-2.52 2.05-4.56 4.57-4.56h5.98c1.82 0 3.3-1.48 3.3-3.3s-1.48-3.3-3.3-3.3Z",
    style: {
      fill: "url(#api_type_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.16 81.85c.39.15.78.22 1.17.22 1.33 0 2.58-.81 3.08-2.13l1.54-4.05h10.62l1.53 4.04a3.287 3.287 0 0 0 4.25 1.92c1.7-.64 2.56-2.55 1.92-4.25l-9.4-24.89c-.6-1.46-2-2.4-3.58-2.4s-2.98.94-3.61 2.48l-9.45 24.8c-.65 1.7.21 3.61 1.91 4.26ZM83.1 69.3h-5.62l2.82-7.42z",
    style: {
      fill: "url(#api_type_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.96 78.77V53.61c0-1.82-1.48-3.3-3.3-3.3s-3.3 1.48-3.3 3.3v25.16c0 1.82 1.48 3.3 3.3 3.3s3.3-1.48 3.3-3.3",
    style: {
      fill: "url(#api_type_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.14 78.77v-7.65c1.37 0 2.84-.01 3.71-.01 5.81 0 10.54-4.66 10.54-10.4s-4.73-10.4-10.54-10.4h-7c-1.82 0-3.3 1.48-3.3 3.3v25.16c0 1.82 1.48 3.3 3.3 3.3s3.3-1.48 3.3-3.3Zm0-21.86h3.71c2.14 0 3.94 1.74 3.94 3.8s-1.81 3.8-3.94 3.8c-.86 0-2.33 0-3.71.01V56.9Z",
    style: {
      fill: "url(#api_type_svg2__e)"
    }
  }));
};
export default SvgApiType;